// opervex-frontend/src/hooks/useOpervex.js
import { useMemo } from "react";
import Opervex from "../Opervex";
import { useAuth } from "../contexts/AuthContext";
import OpervexStorage from "../utils/OpervexStorage";

const useOpervex = () => {
  let tenantId = null;

  try {
    const auth = useAuth();
    tenantId = auth?.tenantId;
  } catch {
    tenantId = null;
  }

  // 🔁 fallback seguro
  if (!tenantId) {
    tenantId = OpervexStorage.getTenantId() || OpervexStorage.getTenantIdFromPath();
  }

  const opervex = useMemo(() => {
    if (!tenantId) return null;
    return new Opervex(tenantId);
  }, [tenantId]);

  return opervex;
};

export default useOpervex;
